import { combineReducers } from "redux";
import {
    TOGGLE_LOADING,
    TOGGLE_ALERT
} from '../constants/actionTypes';

const initState = {
    toggleLoading: null,
    toggleAlert: {
        alert: false,
        message: "",
        type: "error"
    }
};

export function toggleLoading(state = initState.toggleLoading, action) {
    switch(action.type) {
        case TOGGLE_LOADING:
            return action.toggleLoading;
        default:
            return state;
    }
}

export function toggleAlert(state = initState.toggleAlert, action) {
    switch(action.type) {
        case TOGGLE_ALERT:
            return action.toggleAlert;
        default:
            return state;
    }
}


export default combineReducers({
    toggleLoading,
    toggleAlert
})